import { render } from "./ArchivedDocumentPage.vue?vue&type=template&id=44a82334&scoped=true&ts=true"
import script from "./ArchivedDocumentPage.vue?vue&type=script&lang=ts"
export * from "./ArchivedDocumentPage.vue?vue&type=script&lang=ts"

import "./ArchivedDocumentPage.vue?vue&type=style&index=0&id=44a82334&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a82334"]])

export default __exports__